<template>
  <div>
    <div v-if="loading" class="text-center my-6">
      <v-progress-circular indeterminate></v-progress-circular>
    </div>
    <div v-else>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: { loading: { type: Boolean, default: false } }
}
</script>

<style>
</style>